import { Controller } from "@hotwired/stimulus"
import { VisiteTrattenute, riparti } from "../lib/visite_trattenute"

// «Carica bonifici e quietanze (PDF)» (Pagamenti.js, 31a5bd1): il pulsante apre la scelta dei file; la scelta invia subito
// (onChange; nessun file, nessun invio). Durante l'invio il Loader2 al posto di Upload e il pulsante disattivato; alla fine,
// riuscito o no, l'input torna vuoto (finally dell'originale). Il risultato (esiti, schede riscritte o il toast d'errore)
// è del server in Turbo Stream; una risposta d'errore che non è un Turbo Stream (500, pagina del proxy) non diventa la
// pagina: toast qui. Nell'originale la richiesta continuava anche lasciando la scheda: qui una visita Turbo fermerebbe
// l'invio, perciò finché la risposta non arriva le visite si trattengono (lib/visite_trattenute.js) e l'ultima riparte a fine invio.
const ERRORE = "Caricamento non riuscito"
const STREAM = "text/vnd.turbo-stream.html"

export default class extends Controller {
  static targets = ["input", "icona", "attesa", "pulsante"]

  connect() { this.visite = new VisiteTrattenute() }

  disconnect() { this.visite.rilascia() }

  scegli() { this.inputTarget.click() }

  scelti() {
    if (!this.inVolo && this.inputTarget.files?.length) this.element.requestSubmit()
  }

  inizio(event) {
    if (event.target !== this.element) return
    this.inVolo = true
    this.visite.trattieni()
    this.inCorso(true)
  }

  risposta(event) {
    if (event.target !== this.element) return
    this.visite.lascia()
    const r = event.detail.fetchResponse
    if (r && !r.succeeded && !(r.contentType || "").startsWith(STREAM)) event.preventDefault()
  }

  fine(event) {
    if (event.target !== this.element) return
    const url = this.visite.rilascia()
    this.inVolo = false
    this.inCorso(false)
    this.inputTarget.value = ""
    const { success, fetchResponse } = event.detail
    if (!success && !(fetchResponse?.contentType || "").startsWith(STREAM)) window.toast?.error?.(ERRORE)
    if (url) riparti(url)
  }

  inCorso(si) {
    this.attesaTargets.forEach((el) => el.classList.toggle("hidden", !si))
    this.iconaTargets.forEach((el) => el.classList.toggle("hidden", si))
    this.pulsanteTarget.disabled = si
  }
}
